import { useTranslation } from "react-i18next";
import { getTranslatedLabel } from "../../../utils/helpers";

const TextareaRHF = (props: any) => {
  const { t } = useTranslation();

  const { register, formField, errors } = props;
  const label = getTranslatedLabel(formField.translations);

  return (
    <>
      <textarea
        {...register}
        type={formField.type}
        name={formField.name}
        className="textArea w-100"
        rows={3}
      />

      {errors[formField.name] && (
        <div className="validation-errors-text-size text-danger mt-1 ms-2">
          {t("dynamic-form.required", { param: label })}
        </div>
      )}
    </>
  );
};

export default TextareaRHF;
